import { render, staticRenderFns } from "./SelectAssessment.vue?vue&type=template&id=8f6b196e&scoped=true&"
import script from "./SelectAssessment.vue?vue&type=script&lang=js&"
export * from "./SelectAssessment.vue?vue&type=script&lang=js&"
import style0 from "./SelectAssessment.vue?vue&type=style&index=0&id=8f6b196e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b196e",
  null
  
)

export default component.exports